(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('localSettingsService', localSettingsService);

	function localSettingsService($log) {
		var storage;

		function isStorageSupported(storage) {
			var key = 'storage_test';
			try {
				window[storage].setItem(key, key);
				window[storage].removeItem(key);
				return true;
			}
			catch (e) {
				return false;
			}
		}

		// We assign `storage` this way to avoid "Access Denied" errors in newer IEs.
		if (isStorageSupported('localStorage')) {
			storage = localStorage;
		}
		else if (isStorageSupported('sessionStorage')) {
			$log.warn('Local settings will only persist through a refresh due to lack of localStorage support.');
			storage = sessionStorage;
		}
		else {
			$log.warn('Local settings will not persist due to lack of localStorage support.');
			storage = (function () {
				var db = {};

				return {
					getItem: function getItem(key) { return db[key]; },
					setItem: function setItem(key, value) { db[key] = value; }
				};
			}());
		}

		var api = {
			get: function (key) {
				var value = storage.getItem(key);

				try {
					return JSON.parse(value);
				}
				catch (e) {
					return null;
				}
			},
			set: function (key, value) {
				storage.setItem(key, JSON.stringify(value));
			}
		};

		api.createSettingAccessor = function (settingName, defaultValue) {
			var hasRead = false;
			var setting;
			return {
				get: function () {
					if (!hasRead) {
						setting = api.get(settingName);
						if (setting === null)
							setting = typeof defaultValue === 'function' ? defaultValue() : defaultValue;

						hasRead = true;
					}
					return setting;
				},
				set: function (value) {
					setting = value;
					api.set(settingName, value);
					hasRead = true;
				}
			};
		};

		return api;
	}
	localSettingsService.$inject = ['$log'];
})();